import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { MainService } from '../../service/main.service';
import { ApiUrls } from '../../apiRouts';
import { ToasterServiceService } from '../../service/toaster.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialog } from '../../shared/confirm-dialog.component';

@Component({
  selector: 'app-subdivision',
  templateUrl: './subdivision.component.html',
  styleUrl: './subdivision.component.scss'
})
export class SubdivisionComponent implements OnInit {
  SubdivisionForm: any = FormGroup;
  buttonclick: boolean = false;
  submitted: boolean = false;
  selectDistrict: any;
  subdivisionData: any;
  district_id: any;
  subdivisionListData: any[] = [];
  @ViewChild('scroll', { read: ElementRef })
  public scroll!: ElementRef<any>;

  constructor(
    private location: Location,
    private route: ActivatedRoute,
    private router: Router,
    private toasterServiceService: ToasterServiceService,
    private fb: FormBuilder,
    private mainService: MainService,    
    public dialog: MatDialog,) {
    this.selectDistrict = this.mainService.selectDistrict;
    this.SubdivisionForm = this.fb.group({
      subdivision_name: ['', [Validators.required]],
      subdivision_id: [0],
    })
  }

  ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      this.district_id = params['id'];
    })
    this.getSubdivision();
  }

  goBackToPrevPage() {
    this.location.back();
  }

  get f() {
    return this.SubdivisionForm.controls;
  }

  GoToVillageList(subdivision_id: any) {
    this.router.navigate(['/city/village/' + subdivision_id]);
  }

  applySearch(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.toLowerCase();
    if (!filterValue) {
      this.subdivisionData = [...this.subdivisionListData];
      return;
    }
    this.subdivisionData = this.subdivisionListData.filter((data: any) => {
      return data.subdivision_name.toLowerCase().includes(filterValue)
    });
  }

  getSubdivision() {
    this.mainService.getApi(ApiUrls.subdivisionList + this.district_id).subscribe((res: any) => {
      if (res.status == 1) {
        this.subdivisionData = res.subdivision
        this.subdivisionListData = res.subdivision
      }
    });
  }

  EditSubdivision(data: any) {
    this.buttonclick = true;
    this.SubdivisionForm.patchValue({
      district_id: data.district_id,
      subdivision_name: data.subdivision_name,
      subdivision_id: data.subdivision_id,
    });
    this.scroll.nativeElement.scrollTop = 0;
  }

  subdivisionAdd() {
    this.submitted = true;
    if (this.SubdivisionForm.valid) {
      let data = {
        district_id: Number(this.district_id),
        subdivision_id: 0,
        subdivision_name: this.SubdivisionForm.value.subdivision_name,
        Action: 'Insert',
      };
      this.mainService.postApi(ApiUrls.addSubdivision, data, 1).subscribe((res: any) => {
        if (res.status == 1) {
          this.toasterServiceService.toastSuccess(res.response);
          this.getSubdivision();
        }
        else {
          this.toasterServiceService.toastError(res.response);
        }
      });
      this.SubdivisionForm.reset();
      this.submitted = false;
    } else {
      this.submitted = true;
    }
  }

  subdivisionEdit() {
    let data = {
      district_id: Number(this.district_id),
      subdivision_id: this.SubdivisionForm.value.subdivision_id,
      subdivision_name: this.SubdivisionForm.value.subdivision_name,
      Action: 'Update',
    };
    if (this.SubdivisionForm.valid) {
      this.mainService.putApi(ApiUrls.editSubdivision, data, 1).subscribe((res: any) => {
        if (res.status == 1) {
          this.toasterServiceService.toastSuccess(res.response);
          this.getSubdivision();
          this.SubdivisionForm.reset();
          this.submitted = false;
          this.buttonclick = false;
        }
      });
    } else {
      this.submitted = true
      this.buttonclick = true;
    }
  }

  openDialog(e: any, data: any): void {
    const dialogRef = this.dialog.open(ConfirmDialog, {
      data: {
        page: 'JobList'
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == 1) {
        this.deleteDistrict(data);
      } else {
        e.source.checked = !e.checked;
        data.status = e.checked == true ? 0 : 1;
      }
    });
  }

  deleteDistrict(data: any) {
    let obj = {
      district_id: 0,
      subdivision_id: Number(data.subdivision_id),
      subdivision_name: this.SubdivisionForm.value.subdivision_name,
      Action: 'DELETE',
    };
    this.mainService.postApi(ApiUrls.addSubdivision, obj, 1).subscribe((res: any) => {
      if (res.status == 1) {
        this.toasterServiceService.toastSuccess(res.response);
        this.getSubdivision();
      }
      else {
        this.toasterServiceService.toastError(res.response);
      }
    });
  }


}

